import React from "react";
import Button from "Components/button/Button";
import { Icon, pageNotFound } from "Icons/index";
import { t } from "i18next";

//eslint-disable-next-line
export default function () {
  return (
    <div className={"w-full h-[--fullVh] bg-white flex flex-col justify-center items-center"}>
      <Icon svg={pageNotFound} width="10rem" />
      <div className="mb-2 text-lg text-[--text] text-center">{t("infoMsg.notFoundURL.msg")}</div>
      <div className="mb-8 text-sm text-center text-[--text-a40]">{t("infoMsg.notFoundURL.desc")}</div>
      <Button onClick={() => (document.location.href = "/")}>button.goToHome</Button>
    </div>
  );
}
